module.exports = __webpack_public_path__ + "img/icon16.9ff3d972.png";